import React, { useRef, useState } from 'react';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import Toastr from '../utils/toastr';
import useMonitorAPIService from '../../services/monitorapiservice';
import {
    DataGrid, Column, Paging
} from 'devextreme-react/data-grid';
import CorporateGroup from './corporateGroup';
import DeleteCorporateGroup from './deleteCorporateGroup';

function CorporateGroupsModal(props) {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const toastrRef = useRef(null);
    const [groups, setGroups] = useState([]);
    const { getOwnCorporateGroups } = useMonitorAPIService();
    const [showNewEdit, setShowNewEdit] = useState(false);
    const [edit, setEdit] = useState(false);
    const [grpData, setGrpData] = useState(null);
    const [showDelete, setShowDelete] = useState(false);

    const onShow = e => {
        setLoading(true);
        getOwnCorporateGroups(props.token, (res) => {
            if (res.data != null && res.data.length > 0) {
                setGroups(res.data);
            } else {
                setGroups([]);
            }
            setLoading(false);
        });
    }

    const editClick = data => {
        setGrpData(data);
        setShowNewEdit(true);
        setEdit(true);
    }
    const newClick = e => {
        setGrpData(null);
        setShowNewEdit(true);
        setEdit(false);
    }
    const deleteClick = data => {
        setGrpData(data);
        setShowDelete(true);
    }

    const editCell = (dataCell) => {
        return (<OverlayTrigger
            key={dataCell.data.id}
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip style={{ position: "fixed" }}>
                {t("edit")}
            </Tooltip>}>
            <Button variant="light-primary" size='sm' onClick={e => editClick(dataCell.data)}><FontAwesomeIcon icon={duotone('pen-to-square')} /></Button>
        </OverlayTrigger>);
    }

    const deleteCell = (dataCell) => {
        return (<OverlayTrigger
            key={dataCell.data.id}
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip style={{ position: "fixed" }}>
                {t("delete")}
            </Tooltip>}>
            <Button variant="light-danger" size='sm' onClick={e => deleteClick(dataCell.data)}><FontAwesomeIcon icon={duotone('trash-can')} /></Button>
        </OverlayTrigger>);
    }

    const toggleNewedit = e => {
        if (e)
            e.preventDefault();
        setShowNewEdit(!showNewEdit);
        onShow();
    }

    const toggleDelete = e => {
        if (e)
            e.preventDefault();
        setShowDelete(!showDelete);
        onShow();
    }

    return (<>
        <Modal rtl={props.rtl} show={props.show} onHide={props.toggleModal} onShow={onShow} size="lg">
            <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                <Modal.Header>
                    <Modal.Title>
                        <FontAwesomeIcon icon={duotone("user-group")} /> {t("corporategroups")}
                    </Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("close")}
                        </Tooltip>}>
                        <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Button variant="light-primary" className='float-end' size='md' onClick={newClick}><FontAwesomeIcon icon={duotone('plus')} /> {t("newcrpgrp")}</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <DataGrid
                                id='crpgrps'
                                dataSource={groups}
                                rowAlternationEnabled={true}
                                keyExpr="id"
                                showBorders={true}
                                noDataText=""
                            >
                                <Column dataField="id" caption={"Id"} width={"10%"} alignment="right" />
                                <Column dataField="name" caption={t("name")} width={"70%"} alignment="left" />
                                <Column caption={""} width={"10%"} cellRender={editCell} alignment="center" />
                                <Column caption={""} width={"10%"} cellRender={deleteCell} alignment="center" />
                                <Paging
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[5, 9, 12, 15]}
                                    showInfo={true} />
                                <Paging defaultPageSize={5} />
                            </DataGrid>
                        </Col>
                    </Row>
                </Modal.Body>
            </BlockUi>
        </Modal>
        <CorporateGroup show={showNewEdit} toggleModal={toggleNewedit} data={grpData} edit={edit}></CorporateGroup>
        <DeleteCorporateGroup show={showDelete} toggleModal={toggleDelete} data={grpData}></DeleteCorporateGroup>
        <Toastr ref={toastrRef} />
    </>)
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(CorporateGroupsModal);
